import { BillingState } from './interface';

export const initialState: BillingState = {
  contracts: { data: [], status: null },
  selectedContractId: null,
  settlements: { data: [], status: null },
  detail: { data: null, status: null },
  dispatches: { data: [], status: null },
  documents: { data: [], status: null },
  reviewLinks: { data: [], status: null },
  recipients: { data: [], status: null },
  checks: { data: [], status: null },
  versions: { data: [], status: null },
  corrections: { data: [], status: null },
  contractPatients: { data: [], status: null },
  busy: false,
};
